<script lang="ts">
  // components
  import ActionBarCard from "@shared/svelte/Components/ActionBarCard.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // stores
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  export let authService;

  // reactives
  $: isMobile = $LayoutStore.isMobile;
</script>

<ActionBarCard titleText={authService?.actionBarTitle} icon="Megaphone" iconFill="black">
  <div
    slot="body"
    class="fizz-flex-vertical fizz-text-medium fizz-text-left fizz-text-strong fizz-inset-square-8 fizz-justify-center fizz-gap-8"
    class:fizz-space-between={!isMobile}
    style="height: 100%;"
    data-testid="retailer-user-auth-pending-post-order"
  >
    <div>
      <div class="fizz-flex-row fizz-space-between">
        <div>
          <p class="fizz-stack-4"><slot name="pending-title" /></p>
          <p class="fizz-text-small fizz-stack-12 normal-weight" style="font-weight: 400"
            >{authService?.actionBarDescription}</p
          >
        </div>
        <div class="fizz-flex-no-shrink" class:fizz-inset-horizontal-16={!isMobile}>
          <Icon type="Containers" width="70" height="70" />
        </div>
      </div>
    </div>
    <div>
      <slot name="pending-buttons" />
    </div>
  </div>
</ActionBarCard>
